module.exports = __webpack_public_path__ + "static/bebe3-b65311274f560d3bbc7349f957935444.png";